<template>
    <div class="simulator-box without-padding end-xs">
        <button @click="callAction" class="btn btn-default" :disabled="loading">
            {{loading ? 'Salvando...' : 'Concluir' }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        action: {
            type: Function,
            default: null,
        },

        loading: Boolean,
    },
    methods: {

        async callAction() {

            if (this.action) {
                await this.action();
            }

            this.nextRoute();
        },

        nextRoute() {
            this.$router.push({name: 'cliente_simulador', params: this.$route.params})
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/FooterSimulador.vue